import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed, useAttrs } from 'vue';

export interface Props {
  secondary?: boolean;
  outlined?: boolean;
  colorScheme?: 'white' | 'primary-dark' | 'primary' | 'primary-2' | 'border';
  full?: boolean;
  rounded?: boolean | string | 'small';
  padding?: string;
  loading?: boolean;
  height?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    secondary: { type: Boolean },
    outlined: { type: Boolean },
    colorScheme: { default: undefined },
    full: { type: Boolean },
    rounded: { type: [Boolean, String], default: 'rounded-lg' },
    padding: { default: 'px-5' },
    loading: { type: Boolean },
    height: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { secondary?: boolean, outlined?: boolean, colorScheme: 'white' | 'primary-dark' | 'primary' | 'primary-2' | 'border', full?: boolean, rounded: boolean | string | 'small', padding: string, loading?: boolean, height: string }

const attrs = useAttrs();

const classes = computed(() => {
  const styleClasses: { [k: string]: boolean | undefined | unknown } = {
    'btn--loading': props.loading,
    'btn--outlined': props.outlined,
    'btn--secondary': props.secondary,
    'btn--disabled': attrs.disabled,
    'btn--white': props.colorScheme === 'white',
    'btn--primary': props.colorScheme === 'primary',
    'btn--primary-2': props.colorScheme === 'primary-2',
    'btn--primary-dark': props.colorScheme === 'primary-dark',
    'btn--border--outlined': props.colorScheme === 'border',
    'w-full': props.full,
  };
  if (props.rounded) {
    if (typeof props.rounded === 'boolean') styleClasses['rounded-full'] = true;
    else if (props.rounded === 'normal') styleClasses['rounded'] = true;
  }
  return styleClasses;
});

return (_ctx: any,_cache: any) => {
  const _component_BaseSpin = _resolveComponent("BaseSpin")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn", [_unref(classes), __props.rounded, __props.padding]]),
    style: _normalizeStyle({ height: __props.height })
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(_component_BaseSpin, {
          key: 0,
          size: "sm",
          color: "white",
          class: "mr-4"
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})